import { BB, measure } from '@utils/utils'
import gsap from 'gsap'
import BaseComponent from './_BaseComponent'

const OFFSET = 100

/* FLOATING TABS
---------------------------------------------------------------------------------------------------- */

export default class FloatingTabs extends BaseComponent {

    constructor($el, namespace) {
        super('FloatingTabs', $el, namespace)

        this.on()
    }

    bindProperties() {
        this.activeTab = null
        this.tabs = getTabs(this.$refs.tab)

        this.onResize()

        this.tabs.forEach(({ $el, isActive }) => $el.classList.toggle('is-active', isActive))
    }

    bindHandlers() {
        this.scrollHandler = () => this.onScroll()
        this.resizeHandler = () => this.onResize()
    }

    bindEvents() {
        const { win, doc } = this.$utils

        this.addListeners(
            [win, 'scroll', this.scrollHandler],
            [doc, 'layoutChange', this.resizeHandler],
        )

        this.tabs.forEach((tab) => {
            this.addListeners(
                [tab.$triggerArea, 'mouseenter', () => this.onMouseEnter(tab)],
                [tab.$triggerArea, 'mouseleave', () => this.onMouseLeave(tab)],
                [tab.$btn, 'click', () => this.onClick(tab)],
            )
        })
    }



    /* Handlers
    --------------------------------------------------------- */

    onMouseEnter(tab) {
        tab.$el.classList.add('is-above')
        this.activeTab = tab

        this.managePosition()
    }


    onMouseLeave(tab) {
        tab.$el.classList.remove('is-above')

        this.activeTab = null
    }

    onClick(tab) {
        this.tabs.forEach((t) => {
            const isActive = t === tab

            t.isActive = isActive
            t.$el.classList.toggle('is-active', isActive)
        })
    }

    onScroll() {
        this.managePositionY()
    }


    onResize() {
        this.tabs.forEach(tab => tab.resize())

        const tallest = this.tabs.reduce((a, c) => Math.max(a, c.boundsOverlay.height), 0)
        gsap.set(this.$el, { '--panelSize': `${tallest}px` })
    }




    /* Actions
    --------------------------------------------------------- */



    /* Values
    --------------------------------------------------------- */

    managePosition() {
        if (!this.activeTab) return
        const { W } = APP.Layout
        const { boundsBtn, boundsOverlay, $el } = this.activeTab

        const isRight = boundsBtn.left + boundsBtn.width >= W / 2

        $el.classList.toggle('is-right', isRight)

        this.managePositionY()
    }

    managePositionY() {
        if (!this.activeTab) return
        const { H } = APP.Layout

        const { boundsBtn, boundsOverlay, $el } = this.activeTab
        const y = boundsBtn.top - window.scrollY

        const isBot = y >= H - boundsOverlay.height - OFFSET

        $el.classList.toggle('is-bot', isBot)
    }

}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */


const getTabs = $els => Array.from($els).map(($el, i)=> ({
    $el,
    $btn: $el.querySelector('.js-FloatingTabs-button'),
    $overlay: $el.querySelector('.js-FloatingTabs-overlay'),
    $triggerArea: $el.querySelector('.js-FloatingTabs-triggerArea'),
    isActive: i === 0,

    boundsBtn: null,
    boundsOverlay: null,

    resize() {
        const { top, left, width, height } = BB(this.$btn)

        this.boundsOverlay = measure(this.$overlay)
        this.boundsBtn = {
            top: top + window.scrollY,
            left,
            width,
            height,
        }
    },
}))
